import { render, staticRenderFns } from "./Firmwares.vue?vue&type=template&id=6070d4c3&scoped=true"
import script from "./Firmwares.vue?vue&type=script&lang=js"
export * from "./Firmwares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6070d4c3",
  null
  
)

export default component.exports